import {bufferTime, catchError, distinct, filter, first, map, mapTo, mergeMap, tap} from "rxjs/operators";
import {iif, of} from "rxjs";
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import {
  API_GET_PROJECT,
  API_GET_PROJECT_DONE,
  API_GET_PROJECTS_DONE,
  getProjectDone
} from "../actions/projects";
import * as R from 'ramda';
import {getProjects$, getProjectsMulti$} from "../services/projects";
import {
  catchErrorsandResume,
  INDIVIDUAL_ID_BUFFER_MS,
  INDIVIDUAL_ID_FETCH_SIZE,
  MODEL_INSERTION_BUFFER_INTERVAL_MS,
  requestDedupInterval$
} from "./index";
import {setView, setViewCache} from "../actions/view";


const SVCLF = setViewCache({loading: false});

const beginLoading = action$ => action$.pipe(
  ofType(API_GET_PROJECT),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setViewCache({loading: true})),
  catchErrorsandResume(20035)
);

const endLoading = action$ => action$.pipe(
  ofType(API_GET_PROJECT_DONE, API_GET_PROJECTS_DONE),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  first(),
  mapTo(setViewCache({loading: false})),
  catchErrorsandResume(20036)
);

const getSingleEpicMulti = action$ => action$.pipe(
  ofType(API_GET_PROJECT),
  distinct(action => action.payload.id, requestDedupInterval$),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  mergeMap(actions => iif(() => actions.length > 1,
    getProjectsMulti$({ ids: actions.map(action => action.payload.id) }).pipe(
      map(({ response }) => setView(response.results)),
      catchError(error => of(SVCLF, networkError({...error, number: '10089-'+error.status})))
    ),
    getProjects$({ id: actions[0].payload.id }).pipe(
      map(({ response }) => getProjectDone(response)),
      catchError(error => {
        if (error.status === 404) return of(getProjectDone({
          resource: { id: actions[0].payload.id },
          permissions: {},
          status: error.status
        }));
        return of(SVCLF, networkError({...error, number: '10114-'+error.status}));
      })
    ),
  )),
  catchErrorsandResume(20037)
);

const processSingleEpic = action$ => action$.pipe(
  ofType(API_GET_PROJECT_DONE),
  map(action => action.payload),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  filter(results => results.length > 0),
  tap(projects => projects[0].callback && projects[0].callback(projects[0].response.resource.id)),
  map(results => results.map(project => project.response)),
  map(results => setView(results)),
  catchErrorsandResume(20039)
);

const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_PROJECTS_DONE),
  filter(action => action.payload && action.payload.results),
  map(action => action.payload.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => setView(results)),
  catchErrorsandResume(20038)
);

export const projectsEpic = combineEpics(
  getSingleEpicMulti,
  processSingleEpic,
  processMultipleEpic,
);



// WEBPACK FOOTER //
// ./src/network/projects.js